import { DateTime } from "luxon";
import type { ManagementCenterHPPDResponse, ManagementCenterPPDResponse } from "../../../utils/models";
import type { DayRow, Metric } from "./types";

export const buildDayRows = (data: ManagementCenterPPDResponse | ManagementCenterHPPDResponse | undefined, metric: Metric, timezone: string): DayRow[] => {
	if (!data) return [];

	const census = data.census;
	const scheduled = metric === "ppd" ? (data as ManagementCenterPPDResponse).ppdScheduled : (data as ManagementCenterHPPDResponse).hppdScheduled;
	const actual = metric === "ppd" ? (data as ManagementCenterPPDResponse).ppdActual : (data as ManagementCenterHPPDResponse).hppdActual;
	const target = metric === "ppd" ? (data as ManagementCenterPPDResponse).targetPpd : (data as ManagementCenterHPPDResponse).targetHppd;

	const allDates = new Set([...Object.keys(census), ...Object.keys(scheduled), ...Object.keys(actual), ...Object.keys(target)]);

	const rows: DayRow[] = [];
	for (const dateStr of allDates) {
		const dt = DateTime.fromISO(dateStr, { zone: timezone });
		const scheduledVal = scheduled[dateStr] ?? 0;
		const actualVal = actual[dateStr] ?? 0;

		rows.push({
			date: dateStr,
			dateDisplay: dt.toFormat("EEE, d MMM yyyy"),
			census: census[dateStr] ?? 0,
			scheduled: scheduledVal,
			actual: actualVal,
			target: target[dateStr] ?? 0,
			difference: actualVal - scheduledVal,
		});
	}

	return rows;
};

export const getDifferenceColor = (base: number, actual: number): string => {
	if (base === 0 && actual === 0) return "text.secondary";
	if (base === 0) return "error.main";
	const pct = (Math.abs(actual - base) / base) * 100;
	if (pct <= 10) return "success.main";
	if (pct <= 50) return "warning.main";
	return "error.main";
};
